import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import { useState, useEffect } from 'react'; 

export default function About({ onHover }) {
  const [ref, inView] = useInView({ threshold: 0.5 });
  const [animatedOnce, setAnimatedOnce] = useState(false);
  
  const props = useSpring({
    from: { transform:  'translateX(-50%)', opacity: 0 },
    to: { transform: inView && !animatedOnce ? 'translateX(-50%)' : 'translateX(0%)', opacity: inView ? 1 : 0 },
    config: { mass: 1, tension: 120, friction: 14, duration: 650, delay: 0 },
  });

  const props2 = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0  },
    to: { transform: inView && !animatedOnce ? 'translateX(50%)' : 'translateX(0%)', opacity: inView ? 1 : 0  },
    config: { mass: 1, tension: 120, friction: 14, duration: 650, delay: 0 },
  });

  useEffect(() => {
    if (inView && !animatedOnce) {
      setAnimatedOnce(true);
    }
  }, [inView, animatedOnce]);


  return (
    <div ref={ref} id='about' className='overflow-x-hidden' onMouseOver={() => onHover("about")}>
      <div id='animify' className='-z-50 mt-12 md:pl-14 md:pr-14 md:w-[1200px] flex flex-col space-y-4 m-10 bg-cover bg-no-repeat bg-center relative md:left-64 p-1'>

        <h1 className='text-3xl pt-2 font-[650] text-[#173b6c] '>About</h1>

        <hr className='relative pb-4 w-12 border-t-4 border-blue-400' />

        <div className='flex flex-col md:flex-row md:space-x-8  justify-center  flex-shrink-0 flex-basis-200 min-w-200'>

          <animated.img style={ (window.innerWidth >= 1200)? props : {}} className='h-96 w-full md:w-96 object-cover' src={process.env.PUBLIC_URL + '/myphotoinoffice.png'} alt="" />

          <animated.div style={ (window.innerWidth >= 1200)? props2 : {}} className=' w-full m-2  flex flex-col '>

            <h1 className='pt-2 pb-2 text-2xl font-[650] text-[#173b6c]'>Aspiring Software Engineer</h1>

            <p className='w-full pt-2 pb-2'>
              Welcome to my personal portfolio website! I am a dedicated Computer Science and Engineering student about to enter my final year of B.Tech engineering at Shri Guru Gobind Singhji College of Engineering and Technology in Nanded.

              As a competitive programmer and problem solver, I have developed a strong proficiency in Data Structures and Algorithms, successfully solving over 1000 DSA problems across various coding platforms. This commitment is evident in my impressive streak of 350 consecutive days on LeetCode, highlighting my consistency and dedication towards coding and personal growth.

              In addition to my skills in programming and problem-solving, I have a growing interest in the field of Machine Learning. While I would classify my expertise as beginner to intermediate level, I have invested time and effort to gain a decent understanding of Machine Learning principles and applications. 
            
            </p>
            <p>
            This knowledge allows me to approach problems analytically and develop innovative solutions.

            As a MERN stack developer, I have crafted several impressive full-stack projects that demonstrate my technical proficiency and creativity in building web applications.

            Furthermore, my enthusiasm for Linux and its open-source nature has led me to explore its vast ecosystem, continuously enhancing my skills and efficiency as a developer.

            To further enrich my practical experiences, I have actively participated in virtual experience programs on the Forage platform, gaining exposure to industry-relevant projects and scenarios.

            With a strong foundation in Computer Science, expertise in Data Structures and Algorithms, and a growing proficiency in Machine Learning, I am eager to take on new challenges and contribute to the ever-evolving field of computer science.
            </p> 

          </animated.div>

        </div>
      </div>
      </div>
  )
}
